import { usePage } from "@inertiajs/react";

import { PosthogPageViewTracker } from "@/components/posthog-pageview-tracker";
import { PosthogUserSync } from "@/components/posthog-user-sync";
import { SentryUserSync } from "@/components/sentry-user-sync";
import type { SharedProps } from "@/serializers";

export function InertiaObservers() {
  const { auth } = usePage<SharedProps>().props;

  return (
    <>
      <PosthogPageViewTracker />
      <PosthogUserSync auth={auth} />
      <SentryUserSync auth={auth} />
    </>
  );
}
